import { datadogRum } from '@datadog/browser-rum'

/**
 * Log at error level
 * @param error Error to log
 * @param context Context to log
 */
export const logError = (
  error: unknown,
  context?: Record<string, unknown>
): void => {
  const VITE_LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL

  if (VITE_LOG_LEVEL.includes('error')) {
    switch (import.meta.env.MODE) {
      case 'development':
        // eslint-disable-next-line no-console
        console.error(error, context)
        break

      default:
        datadogRum.addError(error, context)
        break
    }
  }
}

/**
 * Log at info level as a Datadog RUM custom action.
 * Intentionally not gated by VITE_LOG_LEVEL: RUM actions are lightweight and
 * suppressing them would create blind spots in session replay and funnel analysis.
 * @param name Action name
 * @param context Context to log
 */
export const logInfo = (
  name: string,
  context?: Record<string, unknown>
): void => {
  switch (import.meta.env.MODE) {
    case 'development':
      // eslint-disable-next-line no-console
      console.info(name, context)
      break

    default:
      datadogRum.addAction(name, context)
      break
  }
}
